import { render, staticRenderFns } from "./contrast.vue?vue&type=template&id=22e1faf3&lang=pug&"
import script from "./contrast.vue?vue&type=script&lang=js&"
export * from "./contrast.vue?vue&type=script&lang=js&"
import style0 from "./contrast.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./contrast.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports